/**
 * @generated SignedSource<<00abd6646511ca5fe9e1eeff7dd5a104>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MetaAdCallToAction = "CONTACT_US" | "GET_QUOTE" | "LEARN_MORE" | "SHOP_NOW" | "SIGN_UP" | "SUBSCRIBE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MetaAd$data = {
  readonly approved: boolean;
  readonly brand: {
    readonly id: string;
  };
  readonly callToAction: MetaAdCallToAction | null;
  readonly comments: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly created: boolean;
  readonly description: string | null;
  readonly destinationUrl: string | null;
  readonly displayUrl: string | null;
  readonly facebookPageId: string | null;
  readonly headline: string | null;
  readonly id: string;
  readonly instagramAccountId: string | null;
  readonly name: string | null;
  readonly primaryText: string | null;
  readonly submittedForApproval: boolean;
  readonly visualAssets: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"CreativeDrawerMetaAd" | "MetaAdPreview">;
  readonly " $fragmentType": "MetaAd";
};
export type MetaAd$key = {
  readonly " $data"?: MetaAd$data;
  readonly " $fragmentSpreads": FragmentRefs<"MetaAd">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MetaAd",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MetaAdPreview"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreativeDrawerMetaAd"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "approved",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submittedForApproval",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "callToAction",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "destinationUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "facebookPageId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "instagramAccountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Brand",
      "kind": "LinkedField",
      "name": "brand",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Comment",
      "kind": "LinkedField",
      "name": "comments",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VisualAsset",
      "kind": "LinkedField",
      "name": "visualAssets",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "MetaAd",
  "abstractKey": null
};
})();

(node as any).hash = "57073c741d5b8a58fa34eba15a9ab873";

export default node;
